import styled, { css } from 'styled-components';
import { darkMode, darkPalette } from '../../core/theme';

interface ModalProps {
  readonly $isVisible?: boolean;
  readonly $fixed?: boolean;
}

interface ModalOverlayProps {
  readonly $isVisible?: boolean;
  readonly $isBlurred?: boolean;
}

export const ModalOverlay = styled.div<ModalOverlayProps>`
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  display: flex;
  justify-content: center;
  align-items: center;
  background: transparent;
  z-index: 1000;
  ${({ $isVisible, $isBlurred }) =>
    $isVisible &&
    $isBlurred &&
    css`
      opacity: 1;
      visibility: visible;
      transition: opacity 0.5s;
      background: rgba(0, 0, 0, 0.42);
      -webkit-backdrop-filter: blur(10px);
      backdrop-filter: blur(10px);
    `}
  ${({ $isVisible, $isBlurred }) =>
    $isVisible &&
    $isBlurred &&
    darkMode(css`
      background: ${darkPalette.overlay};
    `)}
`;

export const ModalContent = styled.div<ModalProps>`
  max-width: 343px;
  min-width: 343px;
  height: auto;
  display: flex;
  align-items: center;
  flex-direction: column;
  padding: 23px;
  background: #fff;
  border-radius: 24px;
  opacity: 0;
  transform: translateY(-20px);
  transition:
    opacity 0.3s,
    transform 0.3s;
  z-index: 1100;
  ${({ $isVisible }) =>
    $isVisible &&
    css`
      opacity: 1;
      transform: translateY(0);
    `}
  ${({ $fixed }) =>
    $fixed &&
    css`
      position: fixed;
      bottom: 0;
      left: 50%;
      transform: translateX(-50%);
      max-width: 430px;
      width: 100%;
      display: flex;
      justify-content: center;
      z-index: 1000;
      border-radius: 24px 24px 0 0;
      border-width: 1px 1px 0;
      border-style: solid;
      border-color: #1f7ace;

      @media (max-width: 470px) {
        max-width: 100%;
      }
    `}
  ${darkMode(css`
    background: ${darkPalette.surface};
  `)}
  ${({ $fixed }) =>
    $fixed &&
    darkMode(css`
      background: ${darkPalette.background};
      border-color: ${darkPalette.accentStrong};
    `)}
`;
